import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import AnimatedNumber from 'react-animated-number';

import DeliveryFastIcon from 'Component/DeliveryFastIcon';
import Html from 'Component/Html';
import { BLACK_KEY, M_KEY } from 'Component/Icon/Icon.config';
import { TotalsType } from 'Type/MiniCart.type';
import { formatPrice } from 'Util/Price';

import { FREE_SHIPPING_FULL } from './FreeShippingNotification.config';

import './FreeShippingNotification.style';

/** @namespace Bodypwa/Component/FreeShippingNotification/Component */
export class FreeShippingNotificationComponent extends PureComponent {
    static propTypes = {
        totals: TotalsType.isRequired,
        freeShippingThreshold: PropTypes.string.isRequired
    };

    renderAnimatedAmount() {
        const {
            totals: { grand_total, shipping_incl_tax, quote_currency_code }, freeShippingThreshold
        } = this.props;
        const remainingAmount = Number(freeShippingThreshold) - (grand_total - shipping_incl_tax);
        return (
            <AnimatedNumber
              style={ {
                  transition: '0.8s ease-out'
              } }
              stepPrecision={ 0 }
              value={ remainingAmount }
              // eslint-disable-next-line
              formatValue={ (n) => {
                  return (
                <Html content={ `${ __('You are %s away from free shipping',
                    ` <span class="AnimatedNumber">${formatPrice(n, quote_currency_code)}</span>`)}` }
                />
                  );
              } }
            />
        );
    }

    renderShippingNotification() {
        const { totals: { grand_total, shipping_incl_tax }, freeShippingThreshold } = this.props;
        const remainingAmount = grand_total - shipping_incl_tax;
        const progress = Math.floor((remainingAmount / Number(freeShippingThreshold)) * FREE_SHIPPING_FULL);
        const isFreeShipping = progress >= FREE_SHIPPING_FULL;
        const notificationLabel = isFreeShipping ? __('You’ve got a free shipping!') : this.renderAnimatedAmount();
        const progressStatus = isFreeShipping ? FREE_SHIPPING_FULL : progress;
        return (
            <>
                <div
                  block="FreeShippingNotification"
                  elem="Content"
                  className={ isFreeShipping ? 'Complete' : '' }
                >
                    <DeliveryFastIcon size={ M_KEY } color={ BLACK_KEY } />
                    { notificationLabel }
                </div>
                <div
                  block="FreeShippingNotification"
                  elem="ProgressBar"
                  className={ isFreeShipping ? 'Complete' : '' }
                  style={ { width: `${progressStatus}%` } }
                />
            </>
        );
    }

    render() {
        const {
            freeShippingThreshold
        } = this.props;

        if (!Number(freeShippingThreshold)) {
            return null;
        }

        return (
            <div block="FreeShippingNotification">
                { this.renderShippingNotification() }
            </div>
        );
    }
}

export default FreeShippingNotificationComponent;
